export const BASE_URL = process.env.REACT_APP_BACKEND_URL;
export const SEGMENT_KEY = process.env.REACT_APP_SEGMENT_KEY;
